import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _pt from "prop-types";
var _excluded = ["data-test", "children", "className", "disabled", "full", "hasLoading", "iconOnly", "iconOnlyText", "isLoading", "kind", "role", "small", "tabIndex", "type"];
import React from 'react';
import { Spinner } from '@sainsburys-tech/bolt';
import * as Styled from './Button.styles';

// The Button component uses a styled component wrapper, which means that we can provide an `as`
// prop to render the button as anything we want - a common usecase of this is to use `as='a'` which
// means that we will render an anchor, styled like a button.
// Typing a polymorphic component is pretty difficult, we have followed this guide to type it
// https://www.benmvp.com/blog/polymorphic-react-components-typescript/
function Button(_ref) {
  var _ref$dataTest = _ref['data-test'],
      dataTest = _ref$dataTest === void 0 ? 'component-button' : _ref$dataTest,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      full = _ref.full,
      hasLoading = _ref.hasLoading,
      iconOnly = _ref.iconOnly,
      iconOnlyText = _ref.iconOnlyText,
      isLoading = _ref.isLoading,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'primary' : _ref$kind,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'button' : _ref$role,
      small = _ref.small,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Styled.Button, _extends({
    className: className,
    "data-test": dataTest,
    disabled: disabled,
    full: full,
    hasLoading: hasLoading,
    iconOnly: iconOnly,
    iconOnlyText: iconOnlyText,
    isLoading: isLoading,
    kind: kind,
    role: role,
    small: small,
    tabIndex: tabIndex,
    type: type
  }, props), iconOnly && /*#__PURE__*/React.createElement("span", {
    "aria-label": iconOnlyText
  }), !hasLoading && !isLoading && children, (hasLoading || isLoading) && /*#__PURE__*/React.createElement(Styled.LoadingContainer, {
    "aria-busy": isLoading,
    role: "alert",
    "aria-live": "assertive"
  }, /*#__PURE__*/React.createElement(Styled.ContentContainer, null, children), /*#__PURE__*/React.createElement(Styled.SpinnerContainer, null, /*#__PURE__*/React.createElement(Spinner, {
    kind: kind,
    size: iconOnly ? 30 : 40,
    centered: true
  }))));
}

Button.propTypes = {
  kind: _pt.oneOf(['primary', 'secondary', 'link']),
  full: _pt.bool,
  small: _pt.bool,
  iconOnly: _pt.bool,
  hasLoading: _pt.bool,
  isLoading: _pt.bool,
  iconOnlyText: _pt.string,
  'data-test': _pt.string,
  children: _pt.node.isRequired
};
Button.displayName = 'Button';
export default Button;